<template>
  <div>
    <div class="card-container">
      <div class="card-title">
        设备通断筛选
      </div>
      <div class="card-content">
        <a-form ref="detailForm" class="detail-form" :form="form">
          <a-row>
            <a-col class="search-item" :span="6">
              <a-form-item label="区域" v-bind="formItemLayout">
                <a-cascader
                  v-model="region"
                  :options="options"
                  :load-data="loadData"
                  change-on-select
                  :field-names="{
                    label: 'name',
                    value: 'id',
                    children: 'children'
                  }"
                  placeholder="省市区、街道"
                  @change="changeArea"
                />
              </a-form-item>
            </a-col>
            <a-col class="search-item" :span="6">
              <a-form-item label="小区" v-bind="formItemLayout">
                <a-select
                  v-decorator="['estateId']"
                  allow-clear
                  show-search
                  placeholder="全部"
                  option-filter-prop="children"
                  :filter-option="filterOption"
                >
                  <a-select-option
                    v-for="(item, index) in estateList"
                    :key="index"
                    :value="item.id"
                  >
                    {{ item.housingEstate }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col class="search-item" :span="4" align="right">
              <a-button type="primary" class="mr8" @click="toSearch">
                查询
              </a-button>
              <a-button @click="resetForm">
                重置
              </a-button>
            </a-col>
          </a-row>
        </a-form>
      </div>
    </div>
    <div style="display:flex;">
      <a-button icon="iconkaiqi-01" type="primary" @click="batchHandle(0)">
        批量开启
      </a-button>
      <div style="margin:0 0 17px 30px;">
        <a-button icon="iconguanbi-01" type="primary" @click="batchHandle(1)">
          批量关闭
        </a-button>
      </div>
    </div>
    <div class="card-container mrt16">
      <a-row>
        <a-col :span="12">
          <div class="card-title">
            点位设备通断列表
          </div>
        </a-col>
        <a-col :span="12" align="right">
          <a-badge
            status="success" text="开启状态"
          />
          <span style="margin:0 10px;"></span>
          <a-badge status="default" text="关闭状态" />
        </a-col>
      </a-row>
      <div class="card-content">
        <a-table
          :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
          class="table-content"
          :columns="columns"
          :data-source="formData"
          :loading="loading"
          :pagination="pagination"
          :row-key="record => record.id"
          :scroll="{ x: 1500 }"
          @change="handleTableChange"
        >
          <template slot="deviceList" slot-scope="deviceLists">
            <span
              v-for="(ite,index) in deviceLists"
              :key="index"
              style="margin: 0 10px;"
            >
              <span v-if="ite.isSwitch === 0" style="color: #87d068;">{{ ite.name }}</span>
              <span v-if="ite.isSwitch === 1" style="color: #d3d7d4;">{{ ite.name }}</span>
            </span>
          </template>
          <div slot="action" slot-scope="record" class="btn-list">
            <a-button
              :disabled="record.deviceList.length === 0"
              class="table-btn-link"
              type="link"
              size="small"
              @click="toView(record)"
            >
              控制
            </a-button>
          </div>
        </a-table>
      </div>
    </div>
    <a-modal
      v-model="visible"
      :destroy-on-close="true"

      class="modal" title="设备开关详情"
      width="1160px" ok-text="发送" cancel-text="取消" @cancel="visible=false" @ok="handleOk"
    >
      <template slot="footer">
        <a-button key="back" @click="handleCancel">
          取消
        </a-button>
        <a-button
          key="submit" type="primary" :loading="loading"
          @click="handleOk"
        >
          发送
        </a-button>
      </template>
      <div style="margin-bottom: 20px;">
        <!-- 锦绣华府 -->
        {{ dialogObj.estateName }}
        <a-divider type="vertical" />
        <!-- 大门右侧智能垃圾房 -->
        {{ dialogObj.NAME }}
      </div>
      <div style="display: flex;width: 1152px;flex-wrap: wrap;">
        <div v-for="(item,index) in dialogObj.deviceList" :key="index" style="margin: 0 10px 20px 10px;">
          <a-card
            :title="item.name"
            style="width: 200px;"
          >
            <a slot="extra">
              <a-switch
                checked-children="开"
                un-checked-children="关"
                :default-checked="item.isSwitch === 0"
                @change="item.isSwitch = item.isSwitch === 0 ? 1 : 0"
              />
            </a>
            <div class="icon_img">
              <img :src="item.isSwitch === 0 ? item.img_on : item.img_off">
              <div style="margin-top: 20px;">
                {{ item.isSwitch === 0 ? 'ON':'OFF' }}
              </div>
            </div>
          </a-card>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { getArea, getEstate } from '@/components/mixins/mixins.js'
import { list, operateDevice, batchOperateDevice } from '@/api/deviceOrder.js'
const columns = [
  {
    title: '区域名称',
    dataIndex: 'areaName'
  },
  {
    title: '街道名称',
    dataIndex: 'street'
  },
  {
    title: '小区名称',
    dataIndex: 'estateName'
  },
  {
    title: '点位名称',
    dataIndex: 'NAME'
  },
  {
    title: '智能控制状态',
    dataIndex: 'deviceList',
    align: 'center',
    scopedSlots: { customRender: 'deviceList' }
  },
  {
    title: '操作',
    key: 'operation',
    fixed: 'right',
    width: 120,
    scopedSlots: { customRender: 'action' }
  }
]
export default {
  mixins: [getArea, getEstate],
  data () {
    return {
      loading: false,
      formData: [],
      columns,
      form: this.$form.createForm(this, {}),
      formItemLayout: {
        labelCol: { span: 7 },
        wrapperCol: { span: 17 }
      },
      pagination: {
        current: 1,
        pageSize: 10,
        showSizeChanger: true,
        showQuickJumper: true,
        showTotal: total => '共' + total + '条记录',
        pageSizeOptions: ['10', '20', '30', '40'],
        defaultPageSize: 10,
        total: 0
      },
      visible: false,
      showArea: false,
      imgName: '',
      status: '0',
      scene: '0',
      selectedRowKeys: [],
      cardlist: [
        {
          id: 1,
          name: '空调',
          img_on: 'http://ito-boss-img.oss-cn-hangzhou.aliyuncs.com/material/20210518/16213228350114204bf167f5744eda28e8d64fabf0d17.png',
          img_off: 'http://ito-boss-img.oss-cn-hangzhou.aliyuncs.com/material/20210518/16213245238468e9448a894dc44e485f98fbce60500bb.png'
        },
        {
          id: 2,
          name: '外部灯光',
          img_on: 'http://ito-boss-img.oss-cn-hangzhou.aliyuncs.com/material/20210518/1621323025398a87d7e11a7a64fe18ebfa958ea5bafde.png',
          img_off: 'http://ito-boss-img.oss-cn-hangzhou.aliyuncs.com/material/20210521/16215649852024a4c359142504e6a9fd93b6fdee37828.png'
        },
        {
          id: 3,
          name: '内部灯光',
          img_on: 'http://ito-boss-img.oss-cn-hangzhou.aliyuncs.com/material/20210518/1621323082515665cb2b8c5b045019113b1dae2880cbb.png',
          img_off: 'http://ito-boss-img.oss-cn-hangzhou.aliyuncs.com/material/20210521/1621565074597717224b976f0417bae5b7ef08babfb50.png'
        },
        {
          id: 4,
          name: '水阀',
          img_on: 'http://ito-boss-img.oss-cn-hangzhou.aliyuncs.com/material/20210518/1621322995497d2694f6b58ab4dfa813e1049e1227aaf.png',
          img_off: 'http://ito-boss-img.oss-cn-hangzhou.aliyuncs.com/material/20210521/16215650910363f2f9d68b01d4fa5ac63139a9215b56a.png'
        },
        {
          id: 5,
          name: '除臭精灵',
          img_on: 'http://ito-boss-img.oss-cn-hangzhou.aliyuncs.com/material/20210518/1621322792904270f902b9ef84b09a0f074a1e817ec2b.png',
          img_off: 'http://ito-boss-img.oss-cn-hangzhou.aliyuncs.com/material/20210521/162156510112822f9fff25eb54f2f9e9b6ae2ee041ea2.png'
        },
        {
          id: 6,
          name: '投递系统',
          img_on: 'http://ito-boss-img.oss-cn-hangzhou.aliyuncs.com/material/20210518/162132300836034584166703c4248a6a3c8a89b157caf.png',
          img_off: 'http://ito-boss-img.oss-cn-hangzhou.aliyuncs.com/material/20210521/1621565117894a9eb78c664584e2c8a3fe58c09a6a3d3.png'
        },
        {
          id: 7,
          name: 'LED',
          img_on: 'http://ito-boss-img.oss-cn-hangzhou.aliyuncs.com/material/20210518/1621322760390efba846712c44409bd8afac3661944b3.png',
          img_off: 'http://ito-boss-img.oss-cn-hangzhou.aliyuncs.com/material/20210521/1621565126348affffd1c4879431884548f242cbc2733.png'
        },
        {
          id: 8,
          name: '灭蚊灯',
          img_on: 'http://ito-boss-img.oss-cn-hangzhou.aliyuncs.com/material/20210518/1621322849557213200c5e848493f8b7fe2e322337fa5.png',
          img_off: 'http://ito-boss-img.oss-cn-hangzhou.aliyuncs.com/material/20210521/1621565137724021b10ae41dd455198aebafae14e9dba.png'
        },
        {
          id: 9,
          name: '环境精灵',
          img_on: 'http://ito-boss-img.oss-cn-hangzhou.aliyuncs.com/material/20210518/1621322810391310f618fb41a4a7eae44555f943f0414.png',
          img_off: 'http://ito-boss-img.oss-cn-hangzhou.aliyuncs.com/material/20210521/162156514748949157183297742098301b19c4cfa308f.png'
        }
      ],
      region: [],
      dialogObj: {}
    }
  },
  mounted: function () {
    this.load()
  },
  methods: {
    load () {
      this.getArea('', 2)
      this.getEstate()
      this.getTable()
    },
    getTable () {
      const params = {
        page: this.pagination.current,
        pageSize: this.pagination.pageSize,
        provinceId: this.region[0] || '',
        cityId: this.region[1] || '',
        areaId: this.region[2] || '',
        estateId: this.form.getFieldValue('estateId') || ''
      }
      this.loading = true
      list(params).then(res => {
        this.loading = false
        this.formData = res.result.list
        this.pagination.total = res.result.totalCount
      })
    },
    toView (record) {
      const vm = this
      vm.visible = true
      const dialogData = JSON.parse(JSON.stringify(record))
      dialogData.deviceList.forEach(item => {
        const itemIcon = vm.cardlist.find(s => s.name.includes(item.name))
        item.img_on = itemIcon.img_on
        item.img_off = itemIcon.img_off
      })
      vm.dialogObj = dialogData
    },
    onSwitch (item) {
      item.isSwitch = item.isSwitch === 1 ? 0 : 1
    },
    onSelectChange (selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
    },
    batchHandle (status) {
      if (this.selectedRowKeys.length === 0) {
        this.$message.error('请先勾选要操作的数据')
        return
      }
      const params = {
        ids: this.selectedRowKeys,
        status: status
      }
      batchOperateDevice(params).then(res => {
        if (res.code === 0) {
          this.$message.success(`操作${res.msg}`)
          this.selectedRowKeys = []
          this.getTable()
        }
      })
    },
    handleCancel (e) {
      this.visible = false
    },
    handleOk (e) {
     
      const params = {
        productId: this.dialogObj.id,
        deviceList: this.dialogObj.deviceList
      }
      operateDevice(params).then(res => {
        this.loading = false
        setTimeout(() => {
          if (res.code === 0) {
            this.$message.success(`操作${res.msg}`)
            this.visible = false
            this.loading = true
            this.getTable()
          }
        }, 2000)
      })

      this.detialVisible = false
      this.getTable()

      // this.dialogObj.deviceList = []
    },
    changeArea (areasId) {
      this.estateList = []
      this.form.setFieldsValue({ estateId: undefined })
      if (areasId.length < 4) {
        this.getEstate(areasId)
      } else if (areasId.length === 4) {
        this.getEstate(null, areasId[3])
      }
    },
    toSearch () {
      this.pagination.current = 1
      this.getTable()
    },
    resetForm () {
      this.form.resetFields()
      this.region = []
      this.form.setFieldsValue({ estateId: undefined })
      this.getTable()
      this.getEstate()
    },
    filterOption (input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      )
    },
    handleTableChange (pagination, filters, sorter) {
      const pager = { ...this.pagination }
      pager.current = pagination.current
      pager.pageSize = pagination.pageSize
      this.pagination = pager
      this.getTable()
    }
  }
}
</script>

<style lang="stylus" scoped>
.modal >>> .ant-modal-footer,.icon_img
  text-align center
.card-container
  .card-title
    span
      font-weight normal
      margin-left 30px
      font-size 14px
</style>
